import React, { useState, useEffect } from "react";
import { auth, db, googleProvider } from "../../firebase";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  signOut,
  signInWithPopup,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import "./Signup.css";

const images = [
  "/images/1.jpeg",
  "/images/2.jpeg",
  
];

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("member");
  const [error, setError] = useState("");
  const [currentImage, setCurrentImage] = useState(0);

  const navigate = useNavigate();

  /* 🔁 Auto image change every 10 seconds */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      await Promise.all([
        updateProfile(userCredential.user, { displayName: name }),
        setDoc(doc(db, "users", userCredential.user.uid), {
          name,
          email,
          role,
          createdAt: new Date().toISOString(),
        }),
      ]);

      await signOut(auth);
      navigate("/login", { replace: true });
    } catch {
      setError("Signup failed");
    }
  };

  const handleGoogleSignup = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      await setDoc(
        doc(db, "users", user.uid),
        {
          name: user.displayName || "",
          email: user.email,
          role: "member",
          createdAt: new Date().toISOString(),
        },
        { merge: true }
      );

      navigate("/select-role");
    } catch {
      setError("Google signup failed");
    }
  };

  return (
    <div className="signup-wrapper">
      {/* LEFT — IMAGE SLIDER */}
      <div
        className="signup-left"
        style={{ backgroundImage: `url(${images[currentImage]})` }}
      >
        <div className="left-overlay">
          <h1>Smart Chit Fund</h1>
          <p>Save together. Grow together.</p>
        </div>
      </div>

      {/* RIGHT — FORM (UNCHANGED) */}
      <div className="signup-right">
        <div className="signup-box">
          <h2>Create Account</h2>

          <form onSubmit={handleSignup}>
            <label>Full Name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} required />

            <label>Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} required />

            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />

            <label>Confirm Password</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />

            <label>Role</label>
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="member">Member</option>
              <option value="organizer">Organizer</option>
            </select>

            <button className="signup-btn">Create Account</button>
          </form>

          <div className="divider">OR</div>

          <button className="google-btn" onClick={handleGoogleSignup}>
            <img src="/images/google.webp" alt="Google" className="google-icon" />
            Continue with Google
          </button>

          {error && <p className="error-text">{error}</p>}

          <p className="login-text">
            Already have an account? <Link to="/login">Login here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
